import initApi from "@/api/app/init/init";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc); 
dayjs.extend(timezone);

import { store } from "@/web/components/state/store";
import { GetUserInfo } from "@/employee/components/state/actions/login";
import { getDateByZone } from "./dateFormatUtils";

let timeOffset = null;

const init = async () => {
  let data = await initApi.getData();
  let sTime = dayjs(data)._d;
  let nTime = new Date();
  // let nTime = new Date(getDateByZone(new Date()));
  timeOffset = sTime.getTime() - nTime.getTime();
};

const nowTime = () => {
  let user = GetUserInfo() //store.getState().userInfStateReducer;
  let siteIdCurrent = user && user.userInfo && user.userInfo.siteIdCurrent ? user.userInfo.siteIdCurrent : null
  let timeZone = siteIdCurrent && siteIdCurrent.timeZone ? siteIdCurrent.timeZone : "";

  let nTime = new Date();
  // let nTime = new Date(getDateByZone(new Date()));
  let utcTime = nTime.getTime()// + nTime.getTimezoneOffset() * 60000; // Convert local time to UTC
  let sTime = !timeZone || typeof timeZone === "number" ?  new Date(dayjs(nTime).format("YYYY-MM-DD HH:mm:ss")) : new Date(dayjs(nTime).tz(timeZone).format("YYYY-MM-DD HH:mm:ss")); // Apply timezone offset
  return sTime;

  // let timeZone = -6
  // let nTime = new Date();
  // let sTime = new Date(nTime.getTime() + timeOffset);
  // return sTime;
};
//"Thu May 11 2023 00:00:00 GMT+0800 (China Standard Time)" converted to "2023-05-11"
const formatData = (data) => {
  let timeZone = -6; 
  const date = new Date(data);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};
export default {
  init,
  nowTime,
  formatData
};
